class I18n {
  constructor({ messages, locale, defaultLocale }) {
    this.messages = messages || {}
    this.locale = locale
    this.defaultLocale = defaultLocale
  }

  getLocales() {
    return Object.keys(this.messages)
  }

  get(key, ...params) {
    if (key === undefined || key == null) {
      return key
    }
    if (key.length > 1 && typeof key === "string" && key.startsWith("~")) {
      return key.substr(1)
    }

    if (key instanceof Array && key.length > 1) {
      ;[key, ...params] = key
    }
    let value =
      (this.messages[this.locale()] && this.messages[this.locale()][key]) ||
      (this.messages[this.defaultLocale] &&
        this.messages[this.defaultLocale][key]) ||
      key
    if (params.length > 0) {
      params = params.map(param => this.get(param))
      value = I18n.interpolate(value, params)
    }
    return value
  }

  // interpolate("{0}-2", 1) == "1"
  // interpolate("{0}-{1}", 1, 2) == "1-2"
  // interpolate("{0}-{1}", [1, 2]) == "1-2"
  // interpolate("{0}-{1}", {0:1, 1:2}) == "1-2"
  static interpolate(text, ...params) {
    if (params.length === 1 && typeof params[0] === "object") {
      params = params[0]
    }
    return text.replace(/{[^}]*}/g, toReplace => {
      const value = toReplace.match(/[^{}]/g)
      return params[value]
    })
  }

  install(Vue) {
    I18n.install(Vue, this)
  }

  static install(Vue, options) {
    const i18n = options instanceof I18n ? options : new I18n(options)
    Vue.prototype.$i18n = i18n
    Vue.prototype.$t = function(key, params) {
      return i18n.get(key, params)
    }
  }
}

export { I18n }
